import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { IMenuVisualizacion } from 'src/app/interface/interfaces';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menu: IMenuVisualizacion={};
  constructor(
    private localStorage: LocalStorage,
  ) { 
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        this.menu = resp['menu'];
      }
    )
  }

  ngOnInit() {

    

  }

}
